import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import DropdownMenu from '../../../common/MenuDropdown';
import Buttons from '../../../common/Buttons';
import { getProjectTeamUsersActions, getProjectTeamActions } from '../ProjectController';
import Bedges from '../../../common/Badges';
import { iconLookup } from '../../../pages/team/TeamController';
import OverflowTip from '../../../common/OverflowTip';
import IconToolTip from '../../../common/IconToolTip';
import { textCss, badgeClass } from '../../../common/Css';
import UserPopup from '../../../common/Popups/User';
import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';

export const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    margin: '0',
    '&:not(:last-child)': {
        borderBottom: '1px solid #E5E7EB',
    },
    '&:before': {
        display: 'none',
    },
    '&.Mui-expanded': {
        boxShadow: '0 8px 16px -2px rgba(0, 0, 0, 0.1)',
        transition: 'box-shadow 0.3s ease-in-out',
    }
}));

export const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<motion.span
            className='material-icons text-scogoorange'
            whileHover={{ scale: 1.2 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
        >navigate_next</motion.span>}
        {...props}
    />
))(({ theme }) => ({
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid #E5E7EB',
}));

export const TeamsAccordian = (props) => {
    const { team, projectDetail, canEdit } = props;
    const projectTeamAction = getProjectTeamActions();
    const teamType = team?.type?.toUpperCase();
    const cardImg = iconLookup[teamType];
    const [isExpanded, setIsExpanded] = useState(false);

    const styleIfBlackListUser = (agent) => {
        let style = `${textCss?.headerThree} transition-colors duration-200`;
        return agent?.isBlacklisted ? `${style} text-scogoclosed` : `${style} text-scogo15`;
    };

    const handleAccordionChange = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <motion.div
            className='bg-white rounded-lg shadow-sm'
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            whileHover={{ scale: 1.01 }}
        >
            <Accordion className='bg-white px-4' onChange={handleAccordionChange}>
                <div className='flex'>
                    <AccordionSummary className='flex justify-between w-full h-14 absolute' sx={{ padding: 0 }}>
                        <div className='flex w-full justify-between items-center'>
                            <div className='flex gap-4 items-center w-full'>
                                <Bedges className={`${cardImg.bgClass} ${badgeClass.teamsBadge} leading-5 text-center rounded-lg p-2`}>
                                    <IconToolTip title={cardImg.type}>
                                        <span className='material-icons text-white text-2xl'>{cardImg?.img}</span>
                                    </IconToolTip>
                                </Bedges>
                                <Typography className='capitalize truncate items-center inline max-w-8 font-medium'>
                                    <OverflowTip
                                        textClass={`w-full ${textCss?.headerThree}`}
                                        someLongText={team?.name}
                                    />
                                </Typography>
                                <motion.div
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                                >
                                    <Bedges>
                                        <span className='bg-scogo99 text-white rounded-full h-8 w-8 flex items-center justify-center text-sm font-semibold shadow-sm'>
                                            {team?.member_count}
                                        </span>
                                    </Bedges>
                                </motion.div>
                            </div>
                        </div>
                    </AccordionSummary>
                    {canEdit ? <div className='flex items-center mr-2'>
                        <DropdownMenu
                            componentOrIcon={'more_vert'}
                            dropDownClass={'cursor-pointer text-3xl hover:text-scogoorange transition-colors'}
                            menuData={projectTeamAction}
                            item={team}
                            payload={{ team, projectDetail }}
                        />
                    </div> : null}
                </div>
                <AccordionDetails sx={{ padding: '1rem', paddingX: '1.2rem' }}>
                    <AnimatePresence>
                        {Array.isArray(team?.members) && team?.members.length > 0 ? (
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ staggerChildren: 0.1 }}
                            >
                                {team?.members?.map((member, index) => {
                                    const projectTeamUsersActions = getProjectTeamUsersActions(member);
                                    return (
                                        <motion.div
                                            key={member.id}
                                            className='flex items-center py-2 hover:bg-gray-50 rounded-lg px-3 transition-colors duration-200'
                                            initial={{ opacity: 0, x: -20 }}
                                            animate={{ opacity: 1, x: 0 }}

                                        >
                                            <div className='flex items-center flex-grow'>
                                                <div className='ml-m-9 flex items-center gap-3 w-72 truncate'>
                                                    <div className='max-w-60'>
                                                        <UserPopup
                                                            userId={member.id}
                                                            anchorOrigin={{
                                                                vertical: 'center',
                                                                horizontal: 'left',
                                                            }}
                                                            transformOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            }}
                                                        >
                                                            <motion.p
                                                                className={styleIfBlackListUser(member)}
                                                                whileHover={{ x: 2 }}
                                                            >
                                                                {member.display_name}
                                                            </motion.p>
                                                        </UserPopup>
                                                    </div>
                                                    <div className='w-12'>
                                                        {member.isBlacklisted && (
                                                            <IconToolTip title={'Blacklisted user'}>
                                                                <motion.span
                                                                    className='cursor-pointer material-icons text-scogo99 text-lg hover:text-red-600 transition-colors'
                                                                    whileHover={{ scale: 1.2, rotate: 10 }}
                                                                    whileTap={{ scale: 0.9 }}
                                                                >
                                                                    block
                                                                </motion.span>
                                                            </IconToolTip>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {canEdit && <div className='flex'>
                                                <Buttons>
                                                    <DropdownMenu
                                                        componentOrIcon={'more_vert'}
                                                        dropDownClass={'cursor-pointer text-2xl hover:text-scogoorange transition-colors'}
                                                        menuData={projectTeamUsersActions}
                                                        item={team}
                                                        payload={{
                                                            agent: member,
                                                            projectDetail,
                                                        }}
                                                    />
                                                </Buttons>
                                            </div>}
                                        </motion.div>
                                    );
                                })}
                            </motion.div>
                        ) : (
                            <NoUsersInTeam />
                        )}
                    </AnimatePresence>
                </AccordionDetails>
            </Accordion>
        </motion.div>
    );
};

const NoUsersInTeam = () => {
    return (
        <motion.div
            className='mx-2 my-2 h-12 items-center flex px-6 rounded-lg gap-6 bg-red-50 border border-red-200'
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 15 }}
            whileHover={{
                scale: 1.02,
                boxShadow: "0 2px 10px rgba(239, 68, 68, 0.2)",
                backgroundColor: "#fee2e2"
            }}
        >
            <motion.span
                className='material-icons text-red-500'
                animate={{ rotate: [0, 10, -10, 10, 0] }}
                transition={{ duration: 0.5, delay: 0.2 }}
            >
                info
            </motion.span>
            <motion.p
                className={`${textCss?.headerThree} text-red-700 font-medium`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
            >
                No users in team
            </motion.p>
        </motion.div>
    );
};
